/**
 * Allowed Angular (parent) origins for portal iframe postMessage.
 * Trailing slashes are stripped — do not include paths.
 */

export const ALLOWED_PARENT_ORIGINS = Object.freeze([
  // NEMT Business
  'https://providerdev.nemtbusiness.com',
  'https://provider.nemtbusiness.com',
  // Onecalltms (Ellipses)
  'https://ellipsesdev.onecalltms.com',
  'https://ellipses.onecalltms.com',
  // Local development
  'http://localhost:3000',
  'http://localhost:4200',
]);

/** Strip trailing slash; return '' if invalid. */
export function normalizeOrigin(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s) return '';
  try {
    const url = new URL(s.includes('://') ? s : `https://${s}`);
    return url.origin;
  } catch {
    return s.replace(/\/+$/, '');
  }
}

export function isAllowedParentOrigin(origin) {
  const normalized = normalizeOrigin(origin);
  if (!normalized) return false;
  return ALLOWED_PARENT_ORIGINS.includes(normalized);
}

/** If document.referrer is an allowed parent, return its origin; else null. */
export function getAllowedReferrerOrigin() {
  try {
    if (!document.referrer) return null;
    const origin = new URL(document.referrer).origin;
    return isAllowedParentOrigin(origin) ? origin : null;
  } catch {
    return null;
  }
}
